<!-- メイン -->
<div class="main">
  <!-- メインコンテンツ -->
  <div class="main-content">
    <form [formGroup]="c461InputForm" autocomplete="off">
      <ng-container *ngIf="!confirmFlag">
        <div class="block">
          <div class="page-title">
            <div class="name">連携事例作成</div>
          </div>
          <div class="block-content p-formgrid p-grid p-m-0">
            <div class="p-col-2 cell">
              中学校・高校等
            </div>
            <div class="p-col-10 cell">
              <span> {{ seedsOrganizationName }}</span>
            </div>
            <div class="p-col-2 cell">
              保育所・幼稚園等
            </div>
            <div class="p-col-10 cell">
              <span> {{ needsOrganizationName }}</span>
            </div>
            <div class="p-col-2 cell">
              <div>写真</div>
              <div style="font-weight: normal;padding-top: 20px;">※中学校・高校等/保育所・幼稚園等が登録した写真を利用、または写真をアップロードしてください。</div>
            </div>
            <div class="p-col-10 cell">
              <div class="two_radio_container">
                <div class="radio_container">
                  <p-radioButton value="1" formControlName="icon_image_choice" label="①"></p-radioButton>
                  <div class="file_preview_container_1" pDroppable (onDrop)="drop($event,fileUpload)"
                    (click)="onClick('1')">
                    <div>
                      <div class="p-d-flex p-jc-center">
                        <div class="p-d-flex align-items-center">
                          <img alt="取り組み概要のイメージ画像" *ngIf="iconImagesFromApi['1']" [src]="iconImagesFromApi['1']"
                            class="preview-img" role="presentation" />
                          <div class="preview-img-empty" *ngIf="!iconImagesFromApi['1']">
                            Image
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="radio_container">
                  <p-radioButton value="2" formControlName="icon_image_choice" label="②"></p-radioButton>
                  <div class="file_preview_container_2" pDroppable (onDrop)="drop($event,fileUpload)"
                    (click)="onClick('2')">
                    <div>
                      <div class="p-d-flex p-jc-center">
                        <div class="p-d-flex align-items-center">
                          <img alt="取り組み概要のイメージ画像" *ngIf="iconImagesFromApi['2']" [src]="iconImagesFromApi['2']"
                            class="preview-img" role="presentation" />
                          <div class="preview-img-empty" *ngIf="!iconImagesFromApi['2']">
                            Image
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="radio_upload_container">
                <p-radioButton value="3" formControlName="icon_image_choice" label="アップロード"></p-radioButton>
                <div class="p-d-flex p-ai-center">
                  <p-fileUpload [multiple]="false" accept="image/*" [showUploadButton]="false"
                    [showCancelButton]="false" chooseLabel="ファイルを選択" [customUpload]="true" #fileUpload
                    (onSelect)="uploadFile(null, fileUpload, $event)">
                    <ng-template pTemplate="content" let-files></ng-template>
                    <ng-template pTemplate="file"></ng-template>
                  </p-fileUpload>

                  <button class="p-button p-button-danger p-ml-2 custom-disabled-button" [disabled]="!uploadedImage"
                    (click)="clearFile(fileUpload)">
                    <i class="pi pi-times"></i>&nbsp;キャンセル
                  </button>
                </div>
              </div>
              <div class="file_preview_container" pDroppable (onDrop)="drop($event,fileUpload)">
                <div>
                  <div class="p-d-flex p-jc-center">
                    <div class="p-d-flex align-items-center">
                      <img alt="取り組み概要のイメージ画像" *ngIf="uploadedImage" [src]="uploadedImage" class="preview-img"
                        role="presentation" />
                      <div class="preview-img-empty" *ngIf="!uploadedImage">
                        Image
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="p-col-2 cell">実施概要</div>
            <div class="p-col-10 cell">
              <div class="text_container">
                <div class="side_text_container">
                  <div class="text_bold">中学校・高等学校</div>
                  <div>{{ agenda_solution_overview }}</div>
                </div>
                <div class="side_text_container">
                  <div class="text_bold">保育所・幼稚園等</div>
                  <div>{{ agenda_need_overview }}</div>
                </div>
              </div>
              <textarea pInputTextarea autocomplete="off" formControlName="overview"></textarea>
              <app-validator-message [control]="
                  c461InputForm.get('overview')
                ">
              </app-validator-message>
            </div>
          </div>
        </div>
        <div class="block">
          <div class="block-content p-formgrid p-grid p-m-0">
            <div class="p-col-2 cell">感想</div>
            <div class="p-col-10 cell">
              <div class="text_column_container">
                <div class="side_text_container">
                  <div class="text_bold">中学校・高等学校</div>
                  <textarea title="中学校・高等学校" type="text" pInputTextarea autocomplete="off"
                    style="min-height: 3rem; height: 3rem;" formControlName="title"></textarea>
                  <app-validator-message [control]="
                  c461InputForm.get('title')
                ">
                  </app-validator-message>
                </div>
                <div class="side_text_container">
                  <div class="text_bold">保育所・幼稚園等</div>
                  <textarea title="保育所・幼稚園等" type="text" pInputTextarea autocomplete="off"
                    style="min-height: 3rem; height: 3rem;" formControlName="title_nursery"></textarea>
                  <app-validator-message [control]="
                  c461InputForm.get('title_nursery')
                ">
                  </app-validator-message>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="block">
          <div class="block-content p-formgrid p-grid p-m-0">
            <div class="p-col-2 cell">工夫したこと</div>
            <div class="p-col-10 cell">
              <div class="text_column_container">
                <div class="side_text_container">
                  <div class="text_bold">中学校・高等学校</div>
                  <textarea title="中学校・高等学校" type="text" pInputTextarea autocomplete="off"
                    style="min-height: 3rem; height: 3rem;" formControlName="initial_overview"></textarea>
                  <app-validator-message [control]="
                  c461InputForm.get('initial_overview')
                ">
                  </app-validator-message>
                </div>
                <div class="side_text_container">
                  <div class="text_bold">保育所・幼稚園等</div>
                  <textarea title="保育所・幼稚園等" type="text" pInputTextarea autocomplete="off"
                    style="min-height: 3rem; height: 3rem;" formControlName="initial_overview_nursery"></textarea>
                  <app-validator-message [control]="
                  c461InputForm.get('initial_overview_nursery')
                ">
                  </app-validator-message>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="block">
          <div class="block-content p-formgrid p-grid p-m-0">
            <div class="p-col-2 cell">得られた成果</div>
            <div class="p-col-10 cell">
              <div class="text_column_container">
                <div class="side_text_container">
                  <div class="text_bold">中学校・高等学校</div>
                  <textarea title="中学校・高等学校" type="text" pInputTextarea autocomplete="off"
                    style="min-height: 3rem; height: 3rem;" formControlName="school_name"></textarea>
                  <app-validator-message [control]="
                  c461InputForm.get('school_name')
                ">
                  </app-validator-message>
                </div>
                <div class="side_text_container">
                  <div class="text_bold">保育所・幼稚園等</div>
                  <textarea title="保育所・幼稚園等" type="text" pInputTextarea autocomplete="off"
                    style="min-height: 3rem; height: 3rem;" formControlName="school_name_nursery"></textarea>
                  <app-validator-message [control]="
                  c461InputForm.get('school_name_nursery')
                ">
                  </app-validator-message>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="block">
          <div class="block-content p-formgrid p-grid p-m-0">
            <div class="p-col-2 cell">マッチング情報</div>
            <div class="p-col-10 cell">
              <textarea pInputTextarea autocomplete="off" formControlName="match_information"></textarea>
              <app-validator-message [control]="
                  c461InputForm.get('match_information')
                ">
              </app-validator-message>
            </div>
          </div>
        </div>
        <div class="block">
          <div class="block-content p-formgrid p-grid p-m-0" style="border-bottom: 0px">
            <div class="p-col-2 cell">公開設定</div>
            <div class="p-col-10 cell">
              <p-radioButton value="0" formControlName="public_flg" label="公開"></p-radioButton>
              <p-radioButton value="1" formControlName="public_flg" label="非公開"></p-radioButton>
            </div>
          </div>
        </div>
        <div class="p-col-12 p-d-flex p-jc-center">
          <button pButton class="btn-confirm" type="button" label="確認画面へ" [disabled]="!c461InputForm?.valid"
            (click)="moveC462()"></button>
        </div>
      </ng-container>
      <ng-container *ngIf="confirmFlag">
        <div class="confirm-container">
          <app-c361 [confirmData]="confirmData" [confirmFlag]="true"></app-c361>
        </div>
        <div class="p-col-12 p-d-flex p-jc-center p-mt-2">
          <button pButton type="button" label="登録する" class="btn-register btn-move-c433 p-mr-3"
            (click)="moveC463()"></button>
          <button pButton type="button" label="入力画面へ戻る" class="button2 btn-register" (click)="moveC461()"></button>
        </div>
      </ng-container>
    </form>
  </div>
</div>
<p-toast position="top-center"></p-toast>